module.exports = __webpack_public_path__ + "static/media/Engxg12.49fb3554.png";